/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
import * as schemaConstants from '@/models/Mobile/Android/AndroidManagementV1SchemaConstants'
import { AndroidSkyPolicy } from '@/models/Mobile/Android/AndroidSkyPolicy'
import { cloneDeep } from "lodash";


/**
 * AndroidのポリシーとSkyのポリシーをラップするクラス
 */
export class AndroidPolicyWrapper {

    // Androidのポリシー
    public policy = new schema.AMAPI_Policy();

    // SKYSEAのポリシー
    public skypolicy = new AndroidSkyPolicy();

    static convertDeprecatedPolicy(oldPolicy: Readonly<AndroidPolicyWrapper>): AndroidPolicyWrapper {
        const newPolicy = cloneDeep(oldPolicy);
        AndroidPolicyWrapper.convertDeviceConnectivityManagement(newPolicy);
        return newPolicy;
    }

    private static convertDeviceConnectivityManagement(policy: AndroidPolicyWrapper): void {
        if (!policy.policy.deviceConnectivityManagement) {
            policy.policy.deviceConnectivityManagement = new schema.AMAPI_DeviceConnectivityManagement();
        }
        {
            const hasUsbFileTransferDisabled = typeof policy.policy.usbFileTransferDisabled === "boolean";
            const hasUsbDataAccess = policy.policy.deviceConnectivityManagement.usbDataAccess && policy.policy.deviceConnectivityManagement.usbDataAccess !== schemaConstants.AMAPI_UsbDataAccess_Enums.usbDataAccessUnspecified;
            if (hasUsbFileTransferDisabled && !hasUsbDataAccess) {
                const convertvalue = policy.policy.usbFileTransferDisabled ? schemaConstants.AMAPI_UsbDataAccess_Enums.disAllowUsbFileTransfer : schemaConstants.AMAPI_UsbDataAccess_Enums.allowUsbDataTransfer;
                policy.policy.deviceConnectivityManagement.usbDataAccess = convertvalue;
            }
            else if (!hasUsbDataAccess) {
                const convertvalue = schemaConstants.AMAPI_UsbDataAccess_Enums.allowUsbDataTransfer;
                policy.policy.deviceConnectivityManagement.usbDataAccess = convertvalue;
            }
            policy.policy.usbFileTransferDisabled = undefined;
        }
        {
            const hasWifiConfigDisabled = typeof policy.policy.wifiConfigDisabled === "boolean";
            const hasConfigureWifi = policy.policy.deviceConnectivityManagement.configureWifi && policy.policy.deviceConnectivityManagement.configureWifi !== schemaConstants.AMAPI_ConfigureWifi_Enums.configureWifiUnspecified;
            if (hasWifiConfigDisabled && !hasConfigureWifi) {
                const convertvalue = policy.policy.wifiConfigDisabled ? schemaConstants.AMAPI_ConfigureWifi_Enums.disallowConfiguringWifi : schemaConstants.AMAPI_ConfigureWifi_Enums.allowConfiguringWifi;
                policy.policy.deviceConnectivityManagement.configureWifi = convertvalue;
            }
            else if (!hasConfigureWifi) {
                const convertvalue = schemaConstants.AMAPI_ConfigureWifi_Enums.allowConfiguringWifi;
                policy.policy.deviceConnectivityManagement.configureWifi = convertvalue;
            }
            policy.policy.wifiConfigDisabled = undefined;
        }
    }
}

/**
 * Androidのポリシーをラップするクラス ※Json作成用
 */
export class AndroidPolicyJson {
    // Androidのポリシー
    public policy = new schema.AMAPI_Policy();
}

/**
 * Skyのポリシーをラップするクラス ※Json作成用
 */
export class AndroidSkyPolicyJson {
    // SKYSEAのポリシー
    public skypolicy = new AndroidSkyPolicy();
}
/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
